var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckGraphic = function SvgCheckGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 104,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99EED0",
    d: "M64.374 95.069C91.181 90.48 110.16 68.157 98.145 43.69 83.504 13.872 53.022 6.71 39.174 9.08 12.365 13.668 5.33 44.674 8.766 64.75c4.6 26.871 28.799 34.907 55.608 30.319Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF7E7",
    d: "M59.532 89.459c23.49 0 42.897-16.186 36.235-38.69-8.12-27.428-33.025-37.932-45.158-37.932-23.49 0-33.995 25.288-33.995 42.82 0 23.469 19.428 33.802 42.918 33.802Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66E6B8",
    d: "m46.255 64.425-11.15-11.17-3.796 3.777 14.946 14.972 32.086-32.14-3.77-3.777-28.316 28.338Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00C07B",
    d: "m46.255 61.746-11.15-11.169-3.796 3.777 14.946 14.972 32.086-32.14-3.77-3.777-28.316 28.337Z"
  })));
};
export default SvgCheckGraphic;